import React, { Component } from 'react'
import MenuBar from '../layouts/MenuBar'
import Footer from '../layouts/Footer'
import { connect } from 'react-redux'
import { getPlans } from '../state-management/actions/plans/PlansActions'
import { Link } from 'react-router-dom'
import Helper from '../utils/Helper'

class Pricing extends Component {
  componentDidMount() {
    this.props.getPlans()
  }

  showPlans() {
    // const { plans } = this.props
    let plans = [
   
      { id: 1, name: 'RESIDENTIAL UNLIMITED', price: '17500', installation_fee: '150000' },

      { id: 3, name: 'RESIDENTIAL PRO', price: '105000', installation_fee: '150000' },
      { id: 4, name: 'RESIDENTIAL YEARLY', price: '210000', installation_fee: '150000' },

      { id: 5, name: 'Office ', price: '150000', installation_fee: '150000' },

      { id: 7, name: 'Turbo Connect', price: '75000', installation_fee: '135000' },
    ]

    if (plans) {
      plans.splice(plans.length - 2, 1)
      // console.log(plans)
      return plans.map((plan, i) => (
        <div key={i} className="pricing-plan col-sm-4 mb-4">
          <div
            className={(() => {
              switch (plan.name) {
                // case 'RESIDENTIAL UNLIMITED Lagos':
                //   return 'whole'
                case 'RESIDENTIAL UNLIMITED':
                  return 'whole'
                case 'RESIDENTIAL PRO':
                  return 'shadow'
                case 'RESIDENTIAL YEARLY':
                  return 'whole'
                case 'Turbo Connect':
                  return 'shadow'
                default:
                  return null
              }
            })()}
          >
            {(function () {
              switch (plan.name) {
                // case 'RESIDENTIAL UNLIMITED Lagos':
                //   return null
                case 'RESIDENTIAL UNLIMITED':
                  return null
                case 'RESIDENTIAL PRO':
                  return (
                    <div className="most-desired p-3">
                      <h5>Most Popular</h5>
                    </div>
                  )
                case 'RESIDENTIAL YEARLY':
                  return null
                case 'Turbo Connect':
                  return (
                    <div className="most-desired p-3">
                      <h5>High Speed</h5>
                    </div>
                  )
                default:
                  return null
              }
            })()}

            {/* normal start */}
            <div
              className={(() => {
                switch (plan.name) {
                  // case 'RESIDENTIAL UNLIMITED Lagos':
                  //   return 'plan-header p-3'
                  case 'RESIDENTIAL UNLIMITED':
                    return 'plan-header p-3'
                  case 'RESIDENTIAL PRO':
                    return 'plan-header p-3'
                  case 'RESIDENTIAL YEARLY':
                    return 'plan-header p-3'
                  case 'Turbo Connect':
                    return 'plan-header p-3'
                  default:
                    return null
                }
              })()}
            >
              {(function () {
                switch (plan.name) {
                  // case 'RESIDENTIAL UNLIMITED Lagos':
                  //   return (
                  //     <h4>
                  //       <span>&#8358;</span>
                  //       {Helper.formatCurrency(plan.price)}/month
                  //     </h4>
                  //   )
                  case 'RESIDENTIAL UNLIMITED':
                    return (
                      <h4>
                        <span>&#8358;</span>
                        {Helper.formatCurrency(plan.price)}/month
                      </h4>
                    )
                  case 'RESIDENTIAL PRO':
                    return (
                      <h4>
                        <span>&#8358;</span>
                        {Helper.formatCurrency(plan.price)}/6months
                      </h4>
                    )
                  case 'RESIDENTIAL YEARLY':
                    return (
                      <h4>
                        <span>&#8358;</span>
                        {Helper.formatCurrency(plan.price)}/Year
                      </h4>
                    )
                  case 'Turbo Connect':
                    return (
                      <h4>
                        <span>&#8358;</span>
                        {Helper.formatCurrency(plan.price)}/Month
                      </h4>
                    )
                  default:
                    return null
                }
              })()}

              {(function () {
                switch (plan.name) {
                  // case 'RESIDENTIAL UNLIMITED Lagos':
                  //   return <h6>{plan.name}</h6>
                  case 'RESIDENTIAL UNLIMITED':
                    return <h6>{plan.name}</h6>
                  case 'RESIDENTIAL PRO':
                    return <h6>{plan.name}</h6>
                  case 'RESIDENTIAL YEARLY':
                    return <h6>{plan.name}</h6>
                  case 'Turbo Connect':
                    return <h6>{plan.name}</h6>
                  default:
                    return null
                }
              })()}
            </div>
            {/* normal stop */}

            {/* lagos start */}
            <div
              className={(() => {
                switch (plan.name) {
                  case 'RESIDENTIAL UNLIMITED':
                    return 'plan-headerlag p-3'

                  case 'RESIDENTIAL PRO':
                    return 'plan-headerlag p-3'
                  case 'RESIDENTIAL YEARLY':
                    return 'plan-headerlag p-3'

                  default:
                    return null
                }
              })()}
            >
              {(function () {
                switch (plan.name) {
                  case 'RESIDENTIAL UNLIMITED':
                    return (
                      <h4>
                        <span>&#8358;</span>
                        22,500/month
                      </h4>
                    )

                  case 'RESIDENTIAL PRO':
                    return (
                      <h4>
                        <span>&#8358;</span>
                        135,000/6months
                      </h4>
                    )
                  case 'RESIDENTIAL YEARLY':
                    return (
                      <h4>
                        <span>&#8358;</span>
                        270,000/Year
                      </h4>
                    )

                  default:
                    return null
                }
              })()}

              {(function () {
                switch (plan.name) {
                  case 'RESIDENTIAL UNLIMITED':
                    return <h6>RESIDENTIAL UNLIMITED Lagos / Abuja / Rivers</h6>
                  case 'RESIDENTIAL PRO':
                    return <h6>RESIDENTIAL PRO Lagos / Abuja / Rivers</h6>
                  case 'RESIDENTIAL YEARLY':
                    return <h6>RESIDENTIAL YEARLY Lagos / Abuja / Rivers</h6>

                  default:
                    return null
                }
              })()}
            </div>

            {/* lagos stop */}

            <div className="plan-details p-4 text-left">
              {(function () {
                switch (plan.name) {
                  case 'RESIDENTIAL UNLIMITED':
                    return (
                      <>
                        <p>
                          <b>
                            <span className="mr-2">&#10003;</span>
                          </b>
                          plus <span>&#8358;</span> <b>{plan.installation_fee}</b>
                          <br />
                          <span className="ml-4">One-time Setup Fee</span>
                        </p>
                        <p>
                          <b>
                            <span className="mr-2">&#10003;</span>
                          </b>
                          Unlimited Internet
                        </p>
                      </>
                    )
                  case 'RESIDENTIAL PRO':
                    return (
                      <>
                        <p>
                          <b>
                            <span className="mr-2">&#10003;</span>
                          </b>
                          plus <span>&#8358;</span> <b>{plan.installation_fee}</b>
                          <br />
                          <span className="ml-4">One-time Setup Fee</span>
                        </p>
                        <p>
                          <b>
                            <span className="mr-2">&#10003;</span>
                          </b>
                          Unlimited Internet
                        </p>
                      </>
                    )
                  case 'RESIDENTIAL YEARLY':
                    return (
                      <>
                        <p>
                          <b>
                            <span className="mr-2">&#10003;</span>
                          </b>
                          plus <span>&#8358;</span> <b>{plan.installation_fee}</b>
                          <br />
                          <span className="ml-4">One-time Setup Fee</span>
                        </p>
                        <p>
                          <b>
                            <span className="mr-2">&#10003;</span>
                          </b>
                          Unlimited Internet
                        </p>
                      </>
                    )
                  case 'Turbo Connect':
                    return (
                      <>
                        <p>
                          <b>
                            <span className="mr-2">&#10003;</span>
                          </b>
                          plus <span>&#8358;</span> <b>{plan.installation_fee}</b>
                          <br />
                          <span className="ml-4">One-time Setup Fee</span>
                        </p>
                        <p>
                          <b>
                            <span className="mr-2">&#10003;</span>
                          </b>
                          Unlimited Internet
                        </p>
                      </>
                    )
                  default:
                    return null
                }
              })()}

              {(function () {
                switch (plan.name) {
                  // case 'RESIDENTIAL UNLIMITED Lagos':
                  //   return (
                  //     <p className="grey">
                  //       <b>
                  //         <span className="mr-2 cancel-sign">&#xD7;</span>
                  //       </b>
                  //       <s>US IP Address</s>
                  //     </p>
                  //   )
                  case 'RESIDENTIAL UNLIMITED':
                    return (
                      <p className="grey">
                        <b>
                          <span className="mr-2 cancel-sign">&#xD7;</span>
                        </b>
                        <s>US IP Address</s>
                      </p>
                    )
                  case 'RESIDENTIAL PRO':
                    return (
                      <p className="grey">
                        <b>
                          <span className="mr-2 cancel-sign">&#xD7;</span>
                        </b>
                        <s>US IP Address</s>
                        <br />
                        <span className="ml-3">(Requires teleport devices)</span>
                      </p>
                    )
                  case 'RESIDENTIAL YEARLY':
                    return (
                      <p className="grey">
                        <b>
                          <span className="mr-2 cancel-sign">&#xD7;</span>
                        </b>
                        <s>US IP Address</s>
                        <br />
                        <span className="ml-3">(Requires teleport devices)</span>
                      </p>
                    )
                  case 'Turbo Connect':
                    return (
                      <p className="grey">
                        <b>
                          <span className="mr-2 cancel-sign">&#xD7;</span>
                        </b>
                        <s>US IP Address</s>
                        <br />
                        <span className="ml-3">(Requires teleport devices)</span>
                      </p>
                    )
                  default:
                    return null
                }
              })()}

              {(function () {
                switch (plan.name) {
                  // case 'RESIDENTIAL UNLIMITED Lagos':
                  //   return (
                  //     <p>
                  //       <b>
                  //         <span className="mr-2 cancel-sign">&#xD7;</span>
                  //       </b>
                  //       <s>0% discount</s>
                  //     </p>
                  //   )
                  case 'RESIDENTIAL UNLIMITED':
                    return (
                      <p>
                        <b>
                          <span className="mr-2 cancel-sign">&#xD7;</span>
                        </b>
                        <s>0% discount</s>
                      </p>
                    )
                  case 'RESIDENTIAL PRO':
                    return (
                      <p>
                        <b>
                          <span className="mr-2">&#10003;</span>
                        </b>
                        24/7 Support
                      </p>
                    )
                  case 'RESIDENTIAL YEARLY':
                    return (
                      <p>
                        <b>
                          <span className="mr-2">&#10003;</span>
                        </b>
                        24/7 Support
                      </p>
                    )
                  case 'Turbo Connect':
                    return (
                      <p>
                        <b>
                          <span className="mr-2">&#10003;</span>
                        </b>
                        Home {'&'} SMEs
                      </p>
                    )
                  default:
                    return null
                }
              })()}

              {(function () {
                switch (plan.name) {
                  // case 'RESIDENTIAL UNLIMITED Lagos':
                  //   return null
                  case 'RESIDENTIAL UNLIMITED':
                    return null
                  case 'RESIDENTIAL PRO':
                    return (
                      <p>
                        <b>
                          <span className="mr-2">&#10003;</span>
                        </b>
                        One month <b>FREE</b>
                      </p>
                    )
                  case 'RESIDENTIAL YEARLY':
                    return (
                      <p>
                        <b>
                          <span className="mr-2">&#10003;</span>
                        </b>
                        2 months <b>FREE</b>
                      </p>
                    )
                  case 'Turbo Connect':
                    return (
                      <p>
                        <b>
                          <span className="mr-2">&#10003;</span>
                        </b>
                        Upto 50Mbps upward 150Mbps
                      </p>
                    )
                  default:
                    return null
                }
              })()}
            </div>

            {(function () {
              switch (plan.name) {
             
                case 'RESIDENTIAL UNLIMITED':
                  return (
                    <div className="purchase">
                      <Link
                        to={{
                          pathname: '/sign-up',
                          state: {
                            amount: Number(plan.price),
                            plan: plan.name,
                            planName: 'home',
                          },
                        }}
                        className="button green w-100"
                      >
                        Signup
                      </Link>
                    </div>
                  )
                case 'RESIDENTIAL PRO':
                  return (
                    <div className="purchase">
                      <Link
                        to={{
                          pathname: '/sign-up',
                          state: {
                            amount: Number(plan.price),
                            plan: plan.name,
                            planName: 'office',
                          },
                        }}
                        className="button green w-100"
                      >
                        Signup
                      </Link>
                    </div>
                  )
                case 'RESIDENTIAL YEARLY':
                  return (
                    <div className="purchase">
                      <Link
                        to={{
                          pathname: '/sign-up',
                          state: {
                            amount: Number(plan.price),
                            plan: plan.name,
                            planName: 'enterprise',
                          },
                        }}
                        className="button green w-100"
                      >
                        Signup
                      </Link>
                    </div>
                  )
                case 'Turbo Connect':
                  return (
                    <div className="purchase">
                      <a href="https://wifi.com.ng/turboconnect" className="button green w-100">
                        Signup
                      </a>
                    </div>
                  )
                default:
                  return null
              }
            })()}
          </div>
        </div>
      ))
    } else {
      return null
    }
  }

  render() {
    return (
      <div>
        <MenuBar />
        <div className="col-md-6 col-12 m-auto">
          <h4 className="mt-5">Pricing</h4>
          <p>
            We offer different UNLIMITED plans with no data cap, no usage threshold and no limited on number of devices
            that can be connected. Select your preferred plan.
          </p>
        </div>

        <div className="pricing-table d-flex col-md-10 ml-auto mr-auto flex-wrap">
          {this.showPlans()}

          {/* <div className="whole">
              <div className="plan-header p-3">
                <h4>CONTACT US</h4>
                <h6>BUSINESS PLANS</h6>
              </div> */}

          {/* <div className="plan-details p-4 text-left">
                <p>
                  <b>
                    <span className="mr-2">&#10003;</span>
                  </b>
                  Setup price varies
                </p>

                <p>
                  <b>
                    <span className="mr-2">&#10003;</span>
                  </b>
                  Unlimited Internet
                </p>

                <p className="grey">
                  <b>
                    <span className="mr-2 cancel-sign">&#xD7;</span>
                  </b>
                  <s>US IP Address</s>
                  <br />
                  <span className="ml-3">(Requires teleport devices)</span>
                </p>

                <p>
                  <span className="mr-2">&#10003;</span>
                  Discount
                </p>
              </div> */}

          {/* <div className="purchase">
                <a className="button green w-100" href="/">
                  Contact Us
                </a>
              </div> */}
          {/* </div> */}
        </div>
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  plans: state.plans.plans,
})

export default connect(mapStateToProps, { getPlans })(Pricing)
